import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useEffect, useMemo } from 'react'
import { getHomeDataStart } from '../../../store/redux-slices/casinoMenu'
import { checkDelay, setDelay } from '../../../utils/apiDelayHelper'
import useBannerViewport from './useBannerViewport'
import { resolveBanners } from '../../../utils/banner'

const useBanner = ({ pageType, categoryId } = {}) => {
  const { languageChanged, selectedLanguageCode } = useSelector((state) => state?.language)
  const { bannerUrl, casinoCategories } = useSelector((state) => state?.casinoMenu?.gameCategory)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { homeLoading } = useSelector(state => state?.casinoMenu)
  const uiConfig = useSelector(state => state?.uiConfig?.general)
  const isMobile = useBannerViewport()

  useEffect(() => {
    if (checkDelay('getHomeDataStart')) {
      !casinoCategories && !homeLoading && dispatch(getHomeDataStart({ getLang: false, navigate, casinoCategoriesLimit: uiConfig?.casinoCategoriesLimit }))
      setDelay('getHomeDataStart', 300000)
    }
  }, [casinoCategories, homeLoading, languageChanged])

  // Casino pages get the banners of the current category with a Default fallback (AMGP-3866)
  const banners = useMemo(
    () => resolveBanners({ bannerUrl, pageType, categoryId, languageCode: selectedLanguageCode, isMobile }),
    [bannerUrl, pageType, categoryId, selectedLanguageCode, isMobile]
  )

  return {
    banners,
    isMobile,
    selectedLanguageCode
  }
}

export default useBanner
